import $ from 'jquery';

export const init = () => {

	$(document)
		.on('click', '.js-menu__link', function (e) {
			e.preventDefault();

			var $this = $(this),
				$menu = $this.closest('.js-menu'),
				$parent = $this.closest('.js-menu__item'),
				$content = $parent.children('.js-menu__content');

			if ( $parent.hasClass('is-opened') ) {
				$content.slideUp(function() {
					$parent.removeClass('is-opened');
				});
			}
			else {
				$content.slideDown(function() {
					$parent.addClass('is-opened');
				});
			}

			// close other menus of dropdown menu
			$menu.find('.m-dropdown__item').not($parent).find('.m-dropdown__content').slideUp(function() {
				$(this).closest('.m-dropdown__item').not($parent).removeClass('is-opened');
			});
		});

};
